import React from 'react';
import Table from 'react-bootstrap/Table'
import MetricFormatter from 'dashboards/MetricFormatter'
import PDFPage from 'pdfs/PDFPage'

class SEOPdfSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
    console.log(this.props)
  }


  getPageNumber(current) {
    return (current + 1);
  }

  render() {
    let pageNumber = 0;
    let clientsPerPage = 35;
    let clients = Object.keys(this.props.metrics);

    let totals = {}

    clients.map((client) => {["revenue_mtd", "revenue_mtd_last_year","revenue_this_month_projected", "revenue_this_month_last_year", "traffic_mtd", "traffic_mtd_last_year", "traffic_this_month_projected", "traffic_this_month_last_year", "traffic_this_month_yy"].map((metricName) => {  
      let value = this.props.metrics[client][metricName];
      totals[metricName] ? totals[metricName] += value : totals[metricName] = value
    })})

    totals["revenue_mtd_yy"] = (totals["revenue_mtd"] - totals["revenue_mtd_last_year"]) / totals["revenue_mtd_last_year"] * 100
    totals["revenue_this_month_yy"] = (totals["revenue_this_month_projected"] - totals["revenue_this_month_last_year"]) / totals["revenue_this_month_last_year"] * 100
    totals["traffic_mtd_yy"] = (totals["traffic_mtd"] - totals["traffic_mtd_last_year"]) / totals["traffic_mtd_last_year"] * 100
    totals["traffic_this_month_yy"] = (totals["traffic_this_month_projected"] - totals["traffic_this_month_last_year"]) / totals["traffic_this_month_last_year"] * 100

    return (
      <div>
        {
          [...Array(Math.ceil(clients.length / clientsPerPage))].map((x, index) => {
            return (
              <PDFPage pageNumber={pageNumber = this.getPageNumber(pageNumber)} hideLogo={false}>
                <div className="pdf-header justify-content-center">
                  <h1 className="text-white text-center">SEO Summary</h1>
                  <h5 className="text-white text-center">{this.props.date_formatted}</h5>
                </div>
                <div className="mb-2">
                  <Table striped className="mt-2 table-white table-striped metric-table">
                     <thead>
                  <tr>
                    <th className="client-cell client-head" style={{border: "none"}}>Client</th>
                    <th style={{border: "none"}} colSpan="3" className="bg-transparent" key="Revenue MTD"><div className="d-flex justify-content-center">Revenue {this.props.this_month} MTD</div></th>
                    <th style={{border: "none"}} colSpan="3" className="bg-transparent" key="Revenue Projected"><div className="d-flex justify-content-center">Revenue {this.props.this_month} Y/Y</div></th>
                    <th style={{border: "none"}} colSpan="3" className="bg-transparent" key="Traffic MTD"><div className="d-flex justify-content-center">Organic Traffic {this.props.this_month} MTD</div></th>
                    <th style={{border: "none"}} colSpan="3" className="bg-transparent" key="Traffic Projected"><div className="d-flex justify-content-center">Organic Traffic {this.props.this_month} Projected Y/Y</div></th>
                  </tr>
                  <tr className="client-cell client-head" >
                    <th className="client-cell client-head" style={{ backgroundColor: "#EEEEEE", borderTop: "none"}}></th>
                    {
                      [1,2,3,4].map((index) => {
                        return (
                          <React.Fragment key={index}>
                            <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>{this.props.date.substring(0, 4)}</th>
                            <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>{parseInt(this.props.date.substring(0, 4)) - 1}</th>
                            <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>Y/Y</th>
                          </React.Fragment>
                        )
                      })
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    clients.map((clientName) => {
                      return (
                        <tr key={clientName}>
                          <td className="client-cell" style={{textAlign: "left", fontWeight: "900"}}>{clientName}</td>
                          {
                            ["revenue_mtd", "revenue_mtd_last_year", "revenue_mtd_yy", "revenue_this_month_projected", "revenue_this_month_last_year", "revenue_this_month_yy", "traffic_mtd", "traffic_mtd_last_year", "traffic_mtd_yy", "traffic_this_month_projected", "traffic_this_month_last_year", "traffic_this_month_yy"].map((metricName) => {
                              let className = "";
                              let value = this.props.metrics[clientName][metricName];
                              if (metricName.includes("yy")) {
                                if (value > 0) {
                                  className = "bg-success text-white font-weight-bold"
                                } else if (value < 0) {
                                  className = "bg-danger text-white font-weight-bold";
                                }
                              }
                              return (
                                <td key={metricName} className={className}>
                                  {
                                    value != 0 ?
                                      metricName.includes("yy") ?
                                       <MetricFormatter.YY value={value} />
                                       : <MetricFormatter.Sessions value={value} />
                                     : <></>
                                  }
                                </td>
                              )
                            })
                          }
                        </tr>
                      )
                    })
                  }
                  <tr>
                    <td className="client-cell" style={{borderTop: "1px solid darkgrey", textAlign: "left", fontWeight: "900"}}>TOTALS</td>
                    {
                      ["revenue_mtd", "revenue_mtd_last_year", "revenue_mtd_yy", "revenue_this_month_projected", "revenue_this_month_last_year", "revenue_this_month_yy", "traffic_mtd", "traffic_mtd_last_year", "traffic_mtd_yy", "traffic_this_month_projected", "traffic_this_month_last_year", "traffic_this_month_yy"].map((metricName) => {
                        let className = "";
                        let value = totals[metricName];
                        if (metricName.includes("yy")) {
                          if (value > 0) {
                            className = "bg-success text-white font-weight-bold"
                          } else if (value < 0) {
                            className = "bg-danger text-white font-weight-bold";
                          }
                        }
                        return (
                          <td style={{borderTop: "1px solid darkgrey"}} key={metricName} className={className}>
                            {
                              value != 0 ?
                                metricName.includes("yy") ?
                                  <MetricFormatter.YY value={value} />
                                  : <MetricFormatter.Sessions value={value} />
                                : <></>
                            }
                          </td>
                        )
                      })
                    }
                  </tr>
                </tbody>
                  </Table>
                </div>
              </PDFPage>
            )
          })
        }
      </div>
    )
  }
}

export default SEOPdfSummary;
